import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Divider, Grid, IconButton } from '@material-ui/core';
import FormRenderer from '../../../framework/Inputs/formRenderer/formRenderer';
import { axiosConfig, GET } from '../../../api/axios';
import { useSelector } from 'react-redux';
import CustomDialog from '../../../framework/dialog/customDialog';
import CustomAddressTable from '../../../framework/CustomAddressTable/CustomAddressTable';
import SearchIcon from '@material-ui/icons/Search';
import {
  formatPostalCodeValues,
  removeUndefinedProperties,
  getCustomerAccountID,
  getWorkingDays,
  setValuesToParcelDetails,
} from '../../../utils/helperFunctions';
import { MIN_SEARCH_RESULTS_REQUIRED } from '../../../utils/constants/constants';
import { renderEmptyText } from '../../../utils/common';
import { DeliveryTypeOptions, SearchByOptions } from '../../../utils/constants/carriageForwardConstants';
import { ServiceEndPoints } from '../../../utils/constants/ApiConstant';
import AddToAddressAndFav from '../../helperComponents/addToAddressAndFav';
import AddressSearch from '../../helperComponents/addessSearch/addressSearch';
import ParcelHandover from '../../carriageForward/parcelHandover/parcelHandover';
import { getServicepointWeight } from '../../../utils/utilsFunctions';
import * as actions from '../../../store/actions/index';
import { connect } from 'react-redux';
import { getCustomDeclaration, getMaxWeightFullcustoms, getServicePointDropOffDetails, getMaxWeightPerParcel, getMinTotalWeight} from '../../../utils/utilsFunctions';
import { MISC_VALUES } from '../../../utils/constants/constants';
import { ERROR_MSG } from '../../../utils/constants/errorConstant';

let dimsValidation = {};

const CollectFrom = (props) => {
  const {
    formField,
    formField: {
      fromAddressType,
      fromSearchFor,
      fromBusinessName,
      fromCustomerNo,
      fromPostCode,
      fromContactName,
      fromAddressLine1,
      fromAddressLine2,
      fromAddressLine3,
      fromTown,
      fromCounty,
      fromTelephoneNumber,
      fromEmailAddress,
      fromCustomerReference,
      collectionInstructions,
      descriptionOfGoods,
      fromWeight,
      fromParcel,
      collectionDate,
    },
    setFieldValue,
    formikValues,
    errors,
    setValues,
    setFromAddressSearchObj,
    allProducts,
    servicePointCollectionData
  } = props;
  const loadedFrom = useSelector((state) => state.loadedFrom.loadedFrom);
  const [openAddressBookModal, setOpenAddressBookModal] = React.useState(false);
  const [customerNumber, setCustomerNumber] = React.useState('');
  const [customerData, setCustomerData] = React.useState([]);
  const [postalSearchData, setPostalSearchData] = React.useState([]);
  const [isItemDisabled, setIsItemDisabled] = React.useState(false);
  const [workingDays, setWorkingDays] = React.useState([]);
  const [isDisPatchDateVisible, setIsDispatchDateVisible] = React.useState(true);
  const [isHandOverDisabled, setHandOverDisabled] = useState(false);
  let addressTypeData = [];
  let leftOverData = [];

  useEffect(() => {
    if (formikValues.handOverMethod === MISC_VALUES.SERVICE_POINT_HANDOVER_METHOD) {
      setIsDispatchDateVisible(false);
    } else if (formikValues.handOverMethod === MISC_VALUES.DRIVER_COLLECTION_HANDOVER_METHOD) {
      setIsDispatchDateVisible(true);
    }
  }, [formikValues.handOverMethod]);

  useEffect(() => {
    const loadHolidayData = async () => {
      let holidayRegion = '';
      formikValues?.accountNumber?.sender?.postalCode &&
        (await axiosConfig
          .get(`${ServiceEndPoints.getPostcodeDistrict}?postcode=${formikValues.accountNumber.sender.postalCode}`)
          .then((res) => {
            holidayRegion = res?.data?.ukHolidayRegion;
          })
          .catch((err) => console.log(err)));
      formikValues.accountNumber?.configuration &&
        GET(`${ServiceEndPoints.getPublicHolidays}?countryCode=gb`)
          .then((res) => {
            const publicHolidays = holidayRegion
              ? res.data?.publicHolidays.filter((holiday) => holiday.region === holidayRegion)
              : res.data?.publicHolidays;
            getWorkingDays(publicHolidays, setWorkingDays);
          })
          .catch((err) => {
            console.log(err);
          });
    };

    loadHolidayData();
  }, [formikValues.accountNumber]);

  useEffect(() => {
    if (
      workingDays.length > 0 &&
      (!formikValues.collectionDate ||
        (formikValues.collectionDate &&
          new Date(formikValues.collectionDate).getTime() < new Date(workingDays[0]).getTime()))
    ) {
      setFieldValue('collectionDate', workingDays[0]);
    }
  }, [formikValues.collectionDate, setFieldValue, workingDays]);

  useEffect(() => {
    if (loadedFrom === '') {
      setFieldValue('collectionDate', workingDays.length > 0 ? workingDays[0] : '');
    }
  }, [workingDays]);

  useEffect(() => {
    if (formikValues.handOverMethod === MISC_VALUES.SERVICE_POINT_HANDOVER_METHOD) {
      setFieldValue('fromParcel', 1);
      setIsItemDisabled(true);
    } else {
      setFieldValue('fromParcel', 1);
      setIsItemDisabled(false);
    }
  }, [formikValues.handOverMethod]);

  useEffect(() => {
    setFieldValue('fromSearchBy', SearchByOptions[0]);
  }, [setFieldValue]);

  React.useEffect(() => {
    setFieldValue('fromSearchFor', '');
  }, [props.formikValues.fromSearchBy]);

  const getCustomerAddressBook = (event) => {
    event.preventDefault();
    const url = `${ServiceEndPoints.getAddressBook}?organization=${getCustomerAccountID()}&${
      formikValues.fromSearchBy.value
    }=${formikValues.fromSearchFor}&countryCode=GB`;
    axiosConfig
      .get(url)
      .then((res) => {
        if (
          formikValues.fromSearchBy.value === MISC_VALUES.CUSTOMER_NUMBER &&
          ((res.data || {}).addressBooks || []).length === 1
        ) {
          rowClicked(res.data.addressBooks[0]);
        } else {
          setOpenAddressBookModal(true);
          setCustomerData(res.data.addressBooks);
        }
      })
      .catch((err) => {
        setOpenAddressBookModal(true);
        setCustomerData([]);
        console.log(err);
      });
  };
  const rowClicked = (val) => {
    const address = val.deliveryAddress;
    setFromAddressSearchObj(val);
    setAddressToForm(address, true, val);
    setCustomerNumber(address.customerNumber);
    setOpenAddressBookModal(false);
  };

  const setAddressToForm = (address, isAddressBook = true, dimsDetails = null) => {
    const { RESIDENTIAL_ADDRESS_TYPE, COMMERCIAL_ADDRESS_TYPE, BUSINESS_ADDRESS_TYPE } = MISC_VALUES;
    let parcelDetails = {};
    const addressObj = {
      fromAddressType: isAddressBook
        ? address.recipientType === 1
          ? BUSINESS_ADDRESS_TYPE
          : RESIDENTIAL_ADDRESS_TYPE
        : address?.type === COMMERCIAL_ADDRESS_TYPE
        ? BUSINESS_ADDRESS_TYPE
        : RESIDENTIAL_ADDRESS_TYPE,
      fromTown: isAddressBook ? address?.town : address.city,
      fromAddressLine1: address?.line1,
      fromAddressLine2: address?.line2,
      fromAddressLine3: address?.line3,
      fromPostCode: isAddressBook ? address?.postCode?.toUpperCase() : address?.postalCode?.toUpperCase(),
      fromBusinessName: isAddressBook ? address?.businessName : address?.company,
      fromCustomerNo: address?.customerNumber,
      fromEmailAddress: address?.email,
      fromContactName: address?.recipientName,
      fromTelephoneNumber: address?.telephone,
      fromCounty: isAddressBook ? address?.county : address?.provinceName,
      fromCustomerReference: dimsDetails?.customerReference ?? '',
      collectionInstructions: dimsDetails?.collectionInstructions,
      descriptionOfGoods: dimsDetails?.descriptionOfGoodsToBeCollected,
    };
    //Set weight & items value
    if (dimsDetails) {
      if (formikValues.handOverMethod === MISC_VALUES.SERVICE_POINT_HANDOVER_METHOD) {
        parcelDetails = {
          fromWeight: dimsDetails.parcelDetails?.weight,
        };
      } else {
        parcelDetails = {
          fromParcel: dimsDetails.parcelDetails?.numberOfItems,
          fromWeight: dimsDetails.parcelDetails?.weight,
        };
      }
    }
    removeUndefinedProperties(addressObj);
    setValues({ ...formikValues, ...addressObj, ...parcelDetails });
  };
  const handleClose = () => {
    setOpenAddressBookModal(false);
  };

  const isResidential = () => {
    return formikValues.fromAddressType === MISC_VALUES.RESIDENTIAL_ADDRESS_TYPE;
  };

  const setValuesFromPostalSearch = (val) => {
    setAddressToForm(val, false);
  };
  const customerNumberBlurred = (eve) => {
    setCustomerNumber(eve.target.value);
  };

  useEffect(() => {
    setFieldValue('sendLabelEmailAddress', formikValues.fromEmailAddress);
  }, [formikValues.fromEmailAddress, setFieldValue]);

  useEffect(() => {
    if (formikValues.fromAddressType === MISC_VALUES.RESIDENTIAL_ADDRESS_TYPE) {
      setFieldValue('fromBusinessName', '');
    }
  }, [formikValues.fromAddressType]);
  const setAddressValues = (addressObj) => {
    const formObj = {
      fromTown: addressObj.city,
      fromAddressLine1: addressObj.line1,
      fromAddressLine2: addressObj.line2,
      fromAddressLine3: addressObj.line3,
      fromPostCode: addressObj.postalCode,
      fromCounty: addressObj.provinceName,
      fromBusinessName: addressObj.company,
    };

    setValues({ ...formikValues, ...formObj });
  };

  const handleAddressChangeByPostCode = (addressType) => {
    if (addressType) {
      if (addressType === MISC_VALUES.COMMERCIAL_ADDRESS_TYPE) {
        setFieldValue('fromAddressType', DeliveryTypeOptions[0].value);
      } else {
        setFieldValue('fromAddressType', DeliveryTypeOptions[1].value);
      }
    }
  };

  useEffect(() => {
    const { MIN, MAX, REQUIRED } = MISC_VALUES;
    const { WEIGHT_REQUIRED, WEIGHT_OUTSIDE_PERMITTED_RANGE, MUST_VALUE_BETWEEN_ONE_TO } = ERROR_MSG;
    axiosConfig
      .get(`${ServiceEndPoints.productCountryFeature}?countrycode=GB`)
      .then((response) => {
        const nonPalletProducts = response.data.filter((val) => val.productCode !== 97 && val.productCode !== 98);

        let allMaxParcelsList = nonPalletProducts.map((x) => x.maximumParcels);
        let allMaxWeightList = nonPalletProducts.map((x) => x.maximumWeight);
        let allMinWeightList = nonPalletProducts.map((x) => x.minimumWeight);

        dimsValidation = {
          ...dimsValidation,
          maxParcels: Math.max(...allMaxParcelsList),
          maxWeight: Math.max(...allMaxWeightList),
          minWeight: Math.min(...allMinWeightList),
          maximumWeightPerParcelWithFullCustoms: getMaxWeightFullcustoms(response.data),
        };
        
        let minWeightValidations = getMinTotalWeight(formikValues, servicePointCollectionData, dimsValidation);

        fromParcel.validation.validations = fromParcel.validation.validations.filter(
          (x) => x.type !== MAX && x.type !== MIN,
        );
        fromParcel.validation.validations.push({
          type: MAX,
          params: [dimsValidation.maxParcels, `${MUST_VALUE_BETWEEN_ONE_TO} ${dimsValidation.maxParcels}`],
        });
        fromParcel.validation.validations.push({
          type: MIN,
          params: [1, `${MUST_VALUE_BETWEEN_ONE_TO} ${dimsValidation.maxParcels}`],
        });
        fromParcel.props.inputProps.max = dimsValidation.maxParcels;

        fromWeight.validation.validations = fromWeight.validation.validations.filter(
          (x) => x.type !== MAX && x.type !== MIN,
        );
        fromWeight.validation.validations.push({
          type: MAX,
          params: [dimsValidation.maxWeight, WEIGHT_OUTSIDE_PERMITTED_RANGE],
        });
        fromWeight.validation.validations.push({
          type: MIN,
          params: [minWeightValidations, WEIGHT_OUTSIDE_PERMITTED_RANGE],
        });
        fromWeight.validation.validations.push({
          type: REQUIRED,
          params: [WEIGHT_REQUIRED],
        });
        fromWeight.props.inputProps.max = dimsValidation.maxWeight;
        props.updateValidationSchema?.();

        // Set the service point details using the weight calculated from the response data in store
        props.setServicePointDetails(getServicepointWeight(response.data));

        // Set the Maximum weight for windsor using the maximumWeightPerParcelWithFullCustoms calculated from the response data in store
        props.setMaxWeightFullcustoms(getMaxWeightFullcustoms(response.data));
      })
      .catch((err) => {
        console.log(err);
      });
  }, [formikValues.handOverMethod, servicePointCollectionData]);

  useEffect(() => {
    if (props.updateValidationSchema) {
      if (!formikValues?.accountNumber?.configuration?.consigneeEmailOptional) {
        !fromEmailAddress.validation.validations.find((x) => x.type === MISC_VALUES.REQUIRED) &&
          fromEmailAddress.validation.validations.push({
            type: MISC_VALUES.REQUIRED,
            params: [ERROR_MSG.EMAIL_REQUIRED],
          });
        fromEmailAddress.props.isRequired = true;
      } else {
        fromEmailAddress.validation.validations = fromEmailAddress.validation.validations.filter(
          (x) => x.type !== MISC_VALUES.REQUIRED,
        );
        fromEmailAddress.props.isRequired = false;
      }
      props.updateValidationSchema();
    }
  }, [formikValues.accountNumber]);

  useEffect(() => {
    if (formikValues.handOverMethod === MISC_VALUES.SERVICE_POINT_HANDOVER_METHOD) {
      const fetchServicePointDetails = async () => {
        const servicePointDetails = await getServicePointDropOffDetails({ code: MISC_VALUES.GBR });
        props.setServicePointCollectionDetails(servicePointDetails);
      };
      fetchServicePointDetails();
    }
  }, [formikValues.handOverMethod]);

  useEffect(() => {
    const { fromWeight, handOverMethod } = formikValues;

    const isServicePoint = handOverMethod === MISC_VALUES.SERVICE_POINT_HANDOVER_METHOD;
    const exceedsServicePointCollectionWeight = fromWeight > servicePointCollectionData?.maxWeight;

    if (isServicePoint && exceedsServicePointCollectionWeight) {
      setFieldValue('handOverMethod', 'driverCollection');
      setHandOverDisabled(true);
    } else {
      setHandOverDisabled(false);
    }
  }, [formikValues.fromWeight, servicePointCollectionData]);

  return (
    <Grid className="wd-100 collectFrom">
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <ParcelHandover
            formField={formField}
            formikValues={formikValues}
            setFieldValue={setFieldValue}
            errors={errors}
            isHandoveDisabled={isHandOverDisabled}
            isCollectionRequest={true}
          />
        </Grid>

        {isDisPatchDateVisible ? (
          <Grid item xs={12} sm={6} md={12} lg={12} spacing={2} style={{ paddingTop: '10px' }}>
            <FormRenderer
              {...collectionDate.props}
              workingDays={workingDays}
              minDate={'nextDay'}
              isWorkingDays={true}
              fullWidth
            />
          </Grid>
        ) : null}
        <Grid item>
          <FormRenderer
            {...fromSearchFor.props}
            selectProps={fromSearchFor.selectProps.props}
            textProps={fromSearchFor.textProps.props}
            data={SearchByOptions}
            onSearchClick={getCustomerAddressBook}
            isIconDisabled={formikValues.fromSearchFor?.trim() === ''}
            fullWidth
          />
          <CustomDialog
            open={openAddressBookModal}
            onClose={handleClose}
            title={customerData.length < 1 ? ERROR_MSG.CUSTOMER_NOT_FOUND : ERROR_MSG.CUSTOMERS_ADDRESS_SEARCH}
          >
            <CustomAddressTable rows={customerData} rowClicked={rowClicked} />
          </CustomDialog>
        </Grid>
        <Grid item>
          <Grid container spacing={2}>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <FormRenderer {...fromParcel.props} isDisabled={isItemDisabled} fullWidth />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <FormRenderer {...fromWeight.props} fullWidth />
            </Grid>
          </Grid>
          {allProducts &&
            getCustomDeclaration(allProducts) &&
            formikValues.fromWeight > formikValues.fromParcel * getMaxWeightPerParcel({code: MISC_VALUES.GBR}, dimsValidation, formikValues, servicePointCollectionData) && (
              <Grid container item style={{ paddingTop: '0px', paddingLeft: '51%' }}>
                <span className="span-required">
                  Parcel weight exceeded. Parcel weight limit is {formikValues.fromParcel * getMaxWeightPerParcel({code: MISC_VALUES.GBR}, dimsValidation, formikValues, servicePointCollectionData)}kg
                  for delivery address
                </span>
              </Grid>
            )}
        </Grid>
        <Grid item>
          <FormRenderer {...fromAddressType.props} data={DeliveryTypeOptions} />
        </Grid>
        <Grid item>
          <FormRenderer {...fromCustomerNo.props} onBlur={(event) => customerNumberBlurred(event)} fullWidth />
        </Grid>
        <Grid item className="delivery-Address">
          <AddressSearch
            setAddressValues={setAddressValues}
            addressType={formikValues.fromAddressType}
            onSelectAddress={handleAddressChangeByPostCode}
            destinationCountrycode2Digit="GB"
            isDomestic={true}
          />
        </Grid>
        <Grid item>
          <FormRenderer {...fromPostCode.props} fullWidth />
        </Grid>
        <Grid item>
          <FormRenderer {...fromContactName.props} fullWidth />
        </Grid>
        {isResidential() ? null : (
          <Grid item>
            <FormRenderer {...fromBusinessName.props} fullWidth />
          </Grid>
        )}
        <Grid item>
          <FormRenderer {...fromAddressLine1.props} fullWidth />
        </Grid>
        <Grid item>
          <FormRenderer {...fromAddressLine2.props} fullWidth />
        </Grid>
        <Grid item>
          <FormRenderer {...fromAddressLine3.props} fullWidth />
        </Grid>
        <Grid item>
          <Grid container direction="row" justify="space-evenly" spacing={2}>
            <Grid item xs={6}>
              <FormRenderer {...fromTown.props} fullWidth />
            </Grid>
            <Grid item xs={6}>
              <FormRenderer {...fromCounty.props} fullWidth />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <FormRenderer {...fromTelephoneNumber.props} fullWidth />
        </Grid>
        <Grid item>
          <FormRenderer {...fromEmailAddress.props} fullWidth />
        </Grid>
        <Grid item>
          <FormRenderer {...fromCustomerReference.props} fullWidth />
        </Grid>
        <Grid item className="heading">
          Collection details
        </Grid>

        <Grid item>
          <FormRenderer {...collectionInstructions.props} fullWidth />
        </Grid>
        <Grid item>
          <FormRenderer {...descriptionOfGoods.props} fullWidth />
        </Grid>
        <Grid item>
          <Divider />
        </Grid>
        <Grid item>
          <AddToAddressAndFav
            formField={formField}
            formikValues={formikValues}
            customerNumber={customerNumber}
            setFieldValue={setFieldValue}
            addToAddressBookControl="fromAddToaddressBook"
            addToFavControlName="fromAddToFavourites"
            updateAddressBookControl="updateFromAddToaddressBook"
            customerNumberControl="fromCustomerNo"
            addressSearchObj={setFromAddressSearchObj}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

CollectFrom.propTypes = {
  formField: PropTypes.object,
  fromAddressType: PropTypes.object,
  fromSearchFor: PropTypes.object,
  fromBusinessName: PropTypes.object,
  fromCustomerNo: PropTypes.object,
  fromPostCode: PropTypes.object,
  fromContactName: PropTypes.object,
  fromAddressLine1: PropTypes.object,
  fromAddressLine2: PropTypes.object,
  fromAddressLine3: PropTypes.object,
  fromTown: PropTypes.object,
  fromCounty: PropTypes.object,
  fromTelephoneNumber: PropTypes.object,
  fromEmailAddress: PropTypes.object,
  fromCustomerReference: PropTypes.object,
  collectionInstructions: PropTypes.object,
  descriptionOfGoods: PropTypes.object,
  setFieldValue: PropTypes.func,
  formikValues: PropTypes.object,
  errors: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    servicePointCollectionData: state.common.servicePointCollectionData
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setServicePointDetails: (data) => {
      dispatch(actions.setServicePointWeight(data));
    },
    setMaxWeightFullcustoms: (data) => {
      dispatch(actions.setMaximumWeightPerParcelWithFullCustoms(data));
    },
    setServicePointCollectionDetails: (data) => {
      dispatch(actions.setServicePointCollectionData(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectFrom);
